import {Component, input} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {RouterLink} from "@angular/router";
import {definePreset} from "@primeng/themes";
import {MyPreset} from "../../theme";

@Component({
  selector: 'homey-details-button',
  standalone: true,
  imports: [
    ButtonModule,
    RouterLink
  ],
  templateUrl: './details-button.component.html',
  styleUrl: './details-button.component.scss'
})
export class DetailsButtonComponent {
  public readonly link = input.required<string[]>();

  buttonDt = definePreset(MyPreset, {
    text: {
      secondary: {
        color: '{surface.300}',
       },
    },
  })
}
